import { validateReduxForm } from 'common/form';
import { NewNote } from 'src/common/form/Interactions/components/NewNote';

const EDIT_GENERAL_NOTE_FORM = 'editGeneralNote';
const fields = [
  'interaction.is_note_private',
  'attached_to',
  'interaction.note',
];

function mapStateToProps(_state, ownProps = {}) {
  const showNoteVisibility = ownProps.detailType === 'profile';

  return {
    initialValues: ownProps.initialValues,
    showNoteVisibility,
  };
}

export default validateReduxForm({
  form: EDIT_GENERAL_NOTE_FORM,
  destroyOnUnmount: true,
  fields,
}, mapStateToProps)(NewNote);
